export default __webpack_public_path__ + "static/media/ic-electricite.f2c6ff5e.svg";